const EmployeeInfo = function (data) {
  if (!data) data = {};
  this.BadgeNo = data.BadgeNo || null;
  this.CompanyName = data.CompanyName || null;
  this.Department = data.Department || null;
  this.EmployeeNo = data.EmployeeNo || null;
  this.LocationId = data.LocationId || null;
  this.LocationName = data.LocationName || null;
  this.Title = data.Title || null;
};
export default EmployeeInfo;
